module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Retiring User","introduction":["You are about to retire the user account “{displayName}” <{email}>. That user will be immediately barred from performing any actions and logged out.",{"full":"{noUndo}, but a new account can always be created for that person with the same email address.","noUndo":"This action cannot be undone"}]}}')
  delete Component.options._Ctor
}
